import React from 'react'
import DecorationLeft from '../../assets/fold2.svg'
import DecorationRight from '../../assets/fold1.svg'

function Decoration() {
  return (
    <>
      <DecorationLeft
        aria-hidden="true"
        className="decoration right show-gt-mobile"
      />
      <DecorationRight
        aria-hidden="true"
        className="decoration left show-gt-mobile"
      />
    </>
  )
}

export default Decoration
